































import { defineComponent } from '@vue/composition-api'
import TeamItem from './TeamItem.vue'

export default defineComponent({
  components: {
    TeamItem,
  },
  props: {
    teams: {
      type: Array,
      default: [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    function removed(teamIndex: number) {
      console.log('team list removed', teamIndex)
      emit('removed', teamIndex)
    }
    return { removed }
  },
})
